import './App.css';
import { Route, Routes, Navigate } from 'react-router-dom';
import ReservationForm from './components/Reservation/reservationForm';
import Confirmation from './components/Reservation/confirmation';
import ManageReservation from './components/Reservation/ManageReservation';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/reservation" />} />
      <Route path='/reservation' element={<ReservationForm />} />
      <Route path='/confirmation' element={<Confirmation />} />
      <Route path='/manage-reservation' element={<ManageReservation />} />
      <Route path='/unauthorized' />
    </Routes>
  );
}

export default App;
